import {
  WizardBody,
  WizardBodyList,
  WizardButton,
  WizardButtonList,
  WizardContent,
} from '../../../ui/wizard/wizard-content';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { PathParams, RoutingPath } from '../../../../routes/routing-path';
import { useParams } from 'react-router-dom';
import { useEnsureTermsAgreement } from '../../../../hooks/use-terms-agreement';

export const Step2StaffPasswordRegisterWizard = () => {
  // - Hooks -
  const dispatch = useDispatch();
  const { kijshopCd } = useParams<PathParams>();
  const { ensureTermsAgreed } = useEnsureTermsAgreement();

  return (
    <WizardContent>
      <WizardBodyList>
        <WizardBody body={['パスワードを登録しました']} />
      </WizardBodyList>
      <WizardButtonList>
        <WizardButton
          label={'閉じる'}
          onClick={() => ensureTermsAgreed(() => dispatch(push(RoutingPath.cnv.orders({ kijshopCd }))))}
        />
      </WizardButtonList>
    </WizardContent>
  );
};
